/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {triggerWelcomeBonus} from '../api'

export const useMutationTriggerWelcomeBonus = createReactQueryMutationHook('triggerWelcomeBonus', triggerWelcomeBonus)
